import React from "react";

import { Box, ListItem, Skeleton } from "@mui/material";

interface NavItemSkeletonProps {
  collapsed: boolean;
}

/**
 * A single placeholder row shown while the nav is loading. Mirrors the layout
 * of CollapsibleNavItem: a circular icon skeleton (centered when collapsed)
 * plus a label-line skeleton that is hidden when collapsed.
 */
const NavItemSkeleton = ({ collapsed }: NavItemSkeletonProps) => {
  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "flex-start",
          minHeight: 48,
          px: collapsed ? 0 : 2.5,
        }}
      >
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          data-testid="nav-item-skeleton-icon"
        />
        {!collapsed && (
          <Skeleton
            variant="text"
            width={120}
            sx={{ ml: 3 }}
            data-testid="nav-item-skeleton-label"
          />
        )}
      </Box>
    </ListItem>
  );
};

export default NavItemSkeleton;
